import React from 'react';

// Display-only: the CURRENT round's collector's payment handles, sourced from
// get_round_collector_payinfo (Stage 29) and passed in as `payinfo`. Renders ONLY
// the methods the collector has set; a graceful fallback when they've added none.
// Direct-to-collector only — the CALLER gates on money_flow_model and only passes a
// non-null payinfo in that case (the RPC returns nothing otherwise). Returns null
// when there is no current collector (no live round / not applicable).
const METHODS = [
  { key: 'zelle_identifier', label: 'Zelle' },
  { key: 'cashapp_handle', label: 'Cash App' },
  { key: 'venmo_handle', label: 'Venmo' },
];

const CollectorPayBlock = ({ payinfo, className = '' }) => {
  if (!payinfo) return null;
  const name = payinfo.collector_name || 'the collector';
  const set = METHODS.filter((m) => payinfo[m.key] && String(payinfo[m.key]).trim());
  return (
    <div className={`rounded-lg border border-primary-200 bg-primary-50 p-3 ${className}`}>
      {set.length > 0 ? (
        <>
          <p className="text-sm font-medium text-primary-900 mb-1">
            Send your payment to {name} using one of these:
          </p>
          <ul className="text-sm text-primary-800 space-y-0.5">
            {set.map((m) => (
              <li key={m.key}>
                <span className="font-medium">{m.label}:</span> {payinfo[m.key]}
              </li>
            ))}
          </ul>
        </>
      ) : (
        <p className="text-sm text-primary-900">
          {name} hasn't added their payment details yet — reach out to them to arrange payment.
        </p>
      )}
    </div>
  );
};

export default CollectorPayBlock;
